export const HAS_TRANSCRIPTION_VALUES = Object.freeze({
  YES: 'YES',
  NO: 'NO',
});

export const isValidHasTranscriptionValue = (hasTranscription) => {
  return !!HAS_TRANSCRIPTION_VALUES[hasTranscription];
};
